import * as React from 'react'

const Card = React.forwardRef(({ className = '', ...props }, ref) => (
  <div
    ref={ref}
    className={['card', className].filter(Boolean).join(' ')}
    {...props}
  />
))
Card.displayName = 'Card'

const CardHeader = React.forwardRef(({ className = '', ...props }, ref) => (
  <div
    ref={ref}
    className={className || undefined}
    style={{ display: 'flex', flexDirection: 'column', gap: '0.375rem', padding: '1.5rem' }}
    {...props}
  />
))
CardHeader.displayName = 'CardHeader'

const CardTitle = React.forwardRef(({ className = '', ...props }, ref) => (
  <h3
    ref={ref}
    className={['font-semibold', className].filter(Boolean).join(' ')}
    style={{ fontSize: '1.5rem', lineHeight: 1 }}
    {...props}
  />
))
CardTitle.displayName = 'CardTitle'

const CardDescription = React.forwardRef(({ className = '', ...props }, ref) => (
  <p
    ref={ref}
    className={['text-muted', className].filter(Boolean).join(' ')}
    style={{ fontSize: '0.875rem' }}
    {...props}
  />
))
CardDescription.displayName = 'CardDescription'

const CardContent = React.forwardRef(({ className = '', ...props }, ref) => (
  <div
    ref={ref}
    className={className || undefined}
    style={{ padding: '1.5rem', paddingTop: '1rem' }}
    {...props}
  />
))
CardContent.displayName = 'CardContent'

const CardFooter = React.forwardRef(({ className = '', ...props }, ref) => (
  <div
    ref={ref}
    className={['flex items-center', className].filter(Boolean).join(' ')}
    style={{ padding: '1.5rem', paddingTop: '1rem' }}
    {...props}
  />
))
CardFooter.displayName = 'CardFooter'

export { Card, CardHeader, CardFooter, CardTitle, CardDescription, CardContent }
